import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Route } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'
import { createBrowserHistory, History } from 'history'
import { css } from 'glamor'

import store from './store'
import { init } from './actions'

import configure from './api/configure'
import config from './config'
import registerServiceWorker from './registerServiceWorker'

import App from './components/App'

import * as fonts from './styles/typography'

import './index.css'

// Order of these two lines matters: want box-sizing to be overidden by normalize/reset
css.global('*, *::before, *::after', { boxSizing: 'border-box' })
import 'glamor/reset'
css.global('html, body', { fontFamily: fonts.fontRegular, fontSize: fonts.fontSizeBase, lineHeight: 1.45 })

const history: History = createBrowserHistory()

configure({ baseUrl: config('api.baseUrl') })
store.dispatch(init(history))

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route
        component={App}
        path="/"
      />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx